import { useEffect, useState } from "react";
import { redirectToLogin, restoreSessionOnStartup } from "../../auth";

type Props = {
  children: React.ReactNode;
};

export function AuthGate({ children }: Props) {
  const [checking, setChecking] = useState(true);
  const [authed, setAuthed] = useState(false);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      const ok = await restoreSessionOnStartup();
      if (cancelled) return;
      setAuthed(ok);
      setChecking(false);
    })();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!checking && !authed) {
      redirectToLogin();
    }
  }, [checking, authed]);

  if (checking || !authed) {
    return (
      <div className="auth-gate-loading" role="status" aria-live="polite">
        <p className="muted">{checking ? "Verifica sessione…" : "Reindirizzamento al login…"}</p>
      </div>
    );
  }

  return <>{children}</>;
}
